import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';

import useMarker from '../../stores/marker';
import useMode from '../../stores/mode';

import Html from '../Html';

const transitions = {
    hidden: {
        y: 24,
        opacity: 0,
        transition: {
            ease: 'circIn',
            duration: 0.2,
        },
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            ease: 'circOut',
            duration: 0.3,
        },
    },
};

function Preview() {
    const marker = useMarker();
    const mode = useMode();

    const [currentMarker, setCurrentMarker] = useState();

    // cache current marker to have it present during exit transition
    useEffect(() => {
        if (marker.getCurrent()) {
            setCurrentMarker(marker.getCurrent());
        }
    }, [marker]);

    return (
        <AnimatePresence initial={false}>
            {marker.visible && marker.id !== null && (
                <motion.div
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={transitions}
                    className="ARPreview"
                    onClick={() => {
                        console.log('ARPreview.onClick()', marker.id);

                        if (marker.id !== null) {
                            if (currentMarker.type === 'link' && currentMarker.link.url) {
                                window.location.href = currentMarker.link.url;
                            } else {
                                mode.set('item');
                            }
                        }
                    }}
                >
                    <div className="ARPreview-content">
                        {currentMarker?.topline && <p className="ARPreview-topline">{currentMarker?.topline}</p>}
                        <h3 className="ARPreview-title">
                            {marker.visible && <Html html={currentMarker?.title}></Html>}
                        </h3>
                        {currentMarker?.subline && <p className="ARPreview-subline">{currentMarker?.subline}</p>}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default Preview;
